import { query } from 'hub-http/middlewares/core';
import { getAcademyLanguage } from '.';
import promiseClient from 'hub-http/adapters/promiseClient';
import hubapiStack from 'hub-http/stacks/hubapi';
import noAuthWithCredentialsHubapi from 'hub-http/stacks/noAuthWithCredentialsHubapi';
import { createStack } from 'hub-http';
import { BASE_URI, BASE_URI_LC, BASE_URI_V2, BASE_URI_V3 } from '../../constants/ApiConstants';
export default promiseClient(hubapiStack);
const academyUris = [BASE_URI, BASE_URI_LC, BASE_URI_V2, BASE_URI_V3]; // We only want to send the language query to academy services

const includeLanguageQuery = options => {
  const language = getAcademyLanguage();
  return academyUris.some(uri => new RegExp(uri).test(options.url)) ? query({
    'hubspot-academy-user-language': language
  }, true)(options) : options;
};
/**
 * These clients are intended to mirror the stacks of the standard
 * http and noAuth clients. Ideally, they should be identical to the
 * stock clients from hub-http
 */


export const http = promiseClient(createStack(includeLanguageQuery, hubapiStack));
export const noAuthApiClient = promiseClient(createStack(includeLanguageQuery, noAuthWithCredentialsHubapi));